import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "cp-icon-arrow-left text-2xl mr-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", {
    class: "inline-flex cursor-pointer text-grey-666 mb-2 hover:opacity-75",
    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleClickBackPrevious && _ctx.handleClickBackPrevious(...args)))
  }, [
    _hoisted_1,
    _createVNode("div", null, _toDisplayString(_ctx.t('returnScreen')), 1)
  ]))
}